import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import LogRocket from 'logrocket'
import { LanguageProvider } from './contexts/LanguageContext'
import App from './App'
import './globals.css'

LogRocket.init('fsek68/paladinoai')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
